package cc.easyandroid.easycompose.component.backhandler

import cc.easyandroid.easycompose.core.backhandler.BackHandler
import cc.easyandroid.easycompose.component.isDestroyed
import cc.easyandroid.easycompose.core.backhandler.BackCallback
import cc.easyandroid.easycompose.core.lifecycle.Lifecycle
import cc.easyandroid.easycompose.core.lifecycle.subscribe

internal interface ChildBackHandler : BackHandler {

    var isEnabled: Boolean
    var priority: Int

    fun start()

    fun stop()
}

internal fun BackHandler.child(
    lifecycle: Lifecycle? = null,
    priority: Int = BackCallback.PRIORITY_DEFAULT,
): BackHandler {
    val handler = childBackHandler(priority = priority, isEnabled = false)

    if (lifecycle == null) {
        handler.isEnabled = true
        handler.start()
    } else if (!lifecycle.isDestroyed) {
        handler.isEnabled = lifecycle.state >= Lifecycle.State.STARTED
        handler.start()

        lifecycle.subscribe(
            onStart = { handler.isEnabled = true },
            onStop = { handler.isEnabled = false },
            onDestroy = handler::stop,
        )
    }

    return handler
}

internal fun BackHandler.childBackHandler(
    isEnabled: Boolean = true,
    priority: Int = BackCallback.PRIORITY_DEFAULT,
): ChildBackHandler =
    DefaultChildBackHandler(
        parent = this,
        isEnabled = isEnabled,
        priority = priority,
    )
